module.exports = __webpack_public_path__ + "static/media/ddk-mainslide-03.bac9912d.jpg";